// React Imports
import * as React from 'react';
import {useEffect, useState, useMemo} from "react";
import {Controller, Form, useFieldArray, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Checkbox, Collapse,
    FormControl, FormControlLabel,
    FormHelperText,
    Input,
    InputLabel, ListItemText, Radio,
    RadioGroup,
    Select,
    Stack, TextField,
    Typography
} from "@mui/material";

// App Imports

import MenuItem from "@mui/material/MenuItem";
import DynamicMultiSelectGridWide from "../../../../CommonComponents/DynamicMultiSelectGridWide";
import {changeContractDrilldownCS} from "../../contractDrilldownSliceCS";
import {
    getContractCS, getHelperData, getHelperItems,
    updateContractSectionContents,
    updateLineItem
} from "../../../../ContractSection/ContractSectionClient";
import {changeContractSection} from "../../../../ContractSection/contractSectionSlice";
import DynamicCdpvValueField from "../../../../CommonComponents/DynamicCdpvValueField";
import {changeHelper} from "../helperSlice";
import {changeCrudSnackbar} from "../../../../CommonComponents/crudSnackbarSlice";
import {getAccountHierarchy} from "../../../../ContractDataPoint/ContractDataPointClient";
import {changeContractDataPointValue} from "../../../../ContractDataPointValue/contractDataPointValueSlice";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import * as PropTypes from "prop-types";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// function ChevronRightIcon(props) {
//     return null;
// }
//
// ChevronRightIcon.propTypes = {sx: PropTypes.shape({transform: PropTypes.any, transition: PropTypes.string})};
// // Main Function
export default function QueryFinancialsGridVersionWide({clearForm}) {
//

    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN REGISTER ****************************

    // const {register, handleSubmit, setValue} = useForm();
    const {
        register,
        control,
        handleSubmit,
        setValue,
        reset
    } = useForm({
        defaultValues: {
            "12406": [{value: ""}],
            "12407": [{value: ""}]
        }
    });

    const {
        fields: lineItemFields,
        append: appendLineItem,
        remove: removeLineItem,
        replace: replaceLineItems
    } = useFieldArray({
        control,
        name: "12406"
    });

    const {
        fields: summaryItemFields,
        append: appendSummaryItem,
        remove: removeSummaryItem,
        replace: replaceSummaryItems
    } = useFieldArray({
        control,
        name: "12407"
    });


    // const lineItemOptions = [
    //     {id: 1, name: "Advertising Coop"},
    //     {id: 4, name: "Advertising Print"},
    //     {id: 7, name: "Distribution Fees"}
    // ];
    //
    // const summaryItemOptions = [
    //     {id: 101, name: "Gross Receipts"},
    //     {id: 102, name: "Allowed Expenses"},
    //     {id: 103, name: "Net Proceeds"}
    // ];

    // ****************** END REGISTER ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);

    const dispatchData = useDispatch() ;

    const [lineItemOptions, setLineItemOptions] = useState([]);
    const [summaryItemOptions, setSummaryItemOptions] = useState([]);

    const filteringMethodDropdown = ["","Has","Does Not Have"];
    const parentItemDropdown = ["","Gross Receipts","Allowed Expenses"];
    const [clearAll, setClearAll] = useState(false);
    // const [selectedFilteringMethod, setSelectedFilteringMethod] = useState('');
    const [selectedParentItem, setSelectedParentItem] = useState('');

    const selectorRawContents = useSelector((state) => state.contractSectionSlc.value.contents);
    const selectorContents = useMemo(() => {
        if (!selectorRawContents) {
            return {};
        }

        if (typeof selectorRawContents === "string") {
            try {
                return JSON.parse(selectorRawContents);
            } catch (error) {
                console.error(
                    "Unable to parse contract-section contents:",
                    error
                );

                return {};
            }
        }

        return selectorRawContents;
    }, [selectorRawContents]);
    // const selectorContents =
    //     typeof selectorRawContents === "string"
    //         ? JSON.parse(selectorRawContents)
    //         : selectorRawContents;

    // const selectorLabel = selectorContents?.["12029"];
    const selectorHelperMode =  useSelector((state) => state.contractDrilldownSlc.value.helperMode);
   const selectorLabel = useSelector((state) => state.helperSlc.value.label);
    const selectorShare = useSelector((state) => state.helperSlc.value.share);
    const selectorNetShare = useSelector((state) => state.helperSlc.value.netShare);
    const selectorRoyalty = useSelector((state) => state.helperSlc.value.royalty);
    const selectorMin = useSelector((state) => state.helperSlc.value.min);
    const selectorMax = useSelector((state) => state.helperSlc.value.max);
    const selectorFrom = useSelector((state) => state.helperSlc.value.fromAmount);
    const selectorTo = useSelector((state) => state.helperSlc.value.toAmount);
    const selectorDateFrom = useSelector((state) => state.helperSlc.value.dateFrom);
    const selectorDateTo = useSelector((state) => state.helperSlc.value.dateTo);
    const selectorAccountAction = useSelector((state) => state.helperSlc.value.accountAction);
    const selectorMarketAction = useSelector((state) => state.helperSlc.value.marketAction);
    const selectorDistributionChannelAction = useSelector((state) => state.helperSlc.value.distributionChannelAction);
    const selectorRegionAction = useSelector((state) => state.helperSlc.value.regionAction);
    const selectorCountryAction = useSelector((state) => state.helperSlc.value.countryAction);
    const selectorLanguageAction = useSelector((state) => state.helperSlc.value.languageAction);
    const selectorSummaryExpression = useSelector((state) => state.helperSlc.value.summaryExpression);
    const selectorSumSign = useSelector((state) => state.helperSlc.value.sumSign);
    const selectorDistributionFee = useSelector((state) => state.helperSlc.value.distributionFee);
    const selectorDistributionFeeMulti = useSelector((state) => state.helperSlc.value.distributionFeeMulti);
    const selectorOverheadFee = useSelector((state) => state.helperSlc.value.overheadFee);
    const selectorOverheadFeeMulti = useSelector((state) => state.helperSlc.value.overheadFeeMulti);
    const selectorDistFeePct = useSelector((state) => state.helperSlc.value.distFeePct);
    const selectorOverheadFeePct = useSelector((state) => state.helperSlc.value.overheadFeePct);

    const selectorMaxNet = useSelector((state) => state.helperSlc.value.maxNet);
    const selectorMaxShare = useSelector((state) => state.helperSlc.value.maxShare);
    const selectorMaxGross = useSelector((state) => state.helperSlc.value.maxGross);
    const selectorGrossesMapping = useSelector((state) => state.helperSlc.value.grossesMapping);
    const selectorExpensesMapping = useSelector((state) => state.helperSlc.value.expensesMapping);
    const selectorAdjGrossMapping = useSelector((state) => state.helperSlc.value.adjGrossMapping);
    const selectorBonusMapping = useSelector((state) => state.helperSlc.value.bonusMapping);

    const selectorMaxFee = useSelector((state) => state.helperSlc.value.maxFee);
    const selectorMaxAmount = useSelector((state) => state.helperSlc.value.maxAmount);
    const selectorMaxResultPct = useSelector((state) => state.helperSlc.value.maxResultPct);
    const selectorMaxResultLimiter = useSelector((state) => state.helperSlc.value.maxResultLimiter);

    const selectorMaxBasis = useSelector((state) => state.helperSlc.value.maxBasis);
    const selectorMaxBasisPct = useSelector((state) => state.helperSlc.value.maxBasisPct);
    const selectorMaxBasisLimiter = useSelector((state) => state.helperSlc.value.maxBasisLimiter);

    const selectorOverheadSubToMax = useSelector((state) => state.helperSlc.value.overheadSubToMax);

    const selectorOverheadMaxFee = useSelector((state) => state.helperSlc.value.overheadMaxFee);
    const selectorOverheadMaxFeePct = useSelector((state) => state.helperSlc.value.overheadMaxFeePct);
    const selectorOverheadMaxFeeLimiter = useSelector((state) => state.helperSlc.value.overheadMaxFeeLimiter);

    const selectorOverheadMaxBasis = useSelector((state) => state.helperSlc.value.overheadMaxBasis);
    const selectorOverheadMaxBasisPct = useSelector((state) => state.helperSlc.value.overheadMaxBasisPct);
    const selectorOverheadMaxBasisLimiter = useSelector((state) => state.helperSlc.value.overheadMaxBasisLimiter);


    const [overheadOpen, setOverheadOpen] = useState(false);


    useEffect(() => {
        register("12574");
        register("12406");
        register("12407");
        register("12029");
        register("12597");
        register("12598");
        register("12018");
        register("12056");
        register("12411");
        register("12412");
        register("12015");
        register("12071");
        register("12072");
        register("12074");
        register("12077");
        register("12080");
        register("12083");
        register("12086");
        register("12089");
        register("12110");
        register("11936");
        register("12100");
        register("12106");
        register("12107");
        register("11929");
        register("3664");
        register("3561");
        register("11644");
        register("12401");
        register("12413");
        register("12417");
        register("12476");
        register("12600");
        register("12601");
        register("12602");
        register("12603");
        register("12604");
        register("12623");
        register("12624");
        register("12625");
        register("12626");
        register("12627");
        register("12628");
        register("12629");
        register("12630");
        register("12631");
        register("12632");
        register("12633");
        register("12634");

    }, [register]);

    useEffect(() => {
        const savedLineItems = Array.isArray(selectorContents?.["12406"])
            ? selectorContents["12406"]
            : [];

        const savedSummaryItems = Array.isArray(selectorContents?.["12407"])
            ? selectorContents["12407"]
            : [];

        reset({
            ...selectorContents,

            "12574": selectorLabel ?? "",
            "12029": selectorLabel ?? "",
            "12597": selectorDistributionFee ?? "",
            "12598": selectorOverheadFee ?? "",
            "12018": selectorRoyalty ?? "",
            "12056": selectorMin ?? "",
            "12015": selectorMax ?? "",
            "12411": selectorFrom ?? "",
            "12412": selectorTo ?? "",
            "12071": selectorDateFrom ?? "",
            "12072": selectorDateTo ?? "",
            "12074": selectorAccountAction ?? "",
            "12077": selectorMarketAction ?? "",
            "12080": selectorDistributionChannelAction ?? "",
            "12083": selectorRegionAction ?? "",
            "12086": selectorCountryAction ?? "",
            "12089": selectorLanguageAction ?? "",
            "11929": selectorShare ?? "",
            "3664": selectorNetShare ?? "",
            "3561": selectorDistFeePct ?? "",
            "11644": selectorOverheadFeePct ?? "",
            "12401": selectorSummaryExpression ?? "",
            "12476": selectorSumSign ?? "4563",
            "12600": <>selectorMaxFee</> ?? "",
            "12601": selectorMaxBasis ?? "",
            "12602": selectorMaxNet ?? "",
            "12603": selectorMaxShare ?? "",
            "12604": selectorMaxGross ?? "",
            "12595": selectorGrossesMapping ?? "",
            "12596": selectorExpensesMapping ?? "",
            "12599": selectorAdjGrossMapping ?? "",
            "12610": selectorBonusMapping ?? "",
            "12623": selectorMaxAmount ?? "",
            "12624": selectorMaxResultLimiter ?? "",
            "12625": selectorMaxResultPct ?? "",
            "12626": selectorMaxBasisLimiter ?? "",
            "12627": selectorMaxBasisPct ?? "",
            "12628": selectorOverheadSubToMax ?? "",
            "12629": selectorOverheadMaxFee ?? "",
            "12630": selectorOverheadMaxBasis ?? "",
            "12631": selectorOverheadMaxFeeLimiter ?? "",
            "12632": selectorOverheadMaxFeePct ?? "",
            "12633": selectorOverheadMaxBasisLimiter ?? "",
            "12634": selectorOverheadMaxBasisPct ?? "",

            "12406":
                savedLineItems.length > 0
                    ? savedLineItems.map(value => ({ value }))
                    : [{ value: "" }],

            "12407":
                savedSummaryItems.length > 0
                    ? savedSummaryItems.map(value => ({ value }))
                    : [{ value: "" }]
        });
    }, [
        selectorContractSectionId,
        selectorRawContents,
        reset
    ]);


    //
    // useEffect(() => {
    //     setValue("12029", selectorLabel ?? "");
    //     setValue("12018", selectorRoyalty ?? "");
    //     setValue("12056", selectorMin ?? "");
    //     setValue("12015", selectorMax ?? "");
    //     setValue("12071", selectorDateFrom ?? "");
    //     setValue("12072", selectorDateTo ?? "");
    //     setValue("12074", selectorAccountAction ?? "");
    //     setValue("12077", selectorMarketAction ?? "");
    //     setValue("12080", selectorDistributionChannelAction ?? "");
    //     setValue("12083", selectorRegionAction ?? "");
    //     setValue("12086", selectorCountryAction ?? "");
    //     setValue("12089", selectorLanguageAction ?? "");
    //     setValue("12110", selectorLabel ?? "");
    //     setValue("11936", selectorLabel ?? "");
    //     setValue("12100", selectorLabel ?? "");
    //     setValue("12106", selectorLabel ?? "");
    //     setValue("12107", selectorLabel ?? "");
    //     setValue("11929", selectorShare ?? "");
    //     setValue("3664", selectorNetShare ?? "");
    //     setValue("12401", selectorSummaryExpression ?? "");


    // }, [
    //     selectorLabel,
    //     selectorShare,
    //     selectorNetShare,
    //     selectorRoyalty,
    //     selectorMin,
    //     selectorMax,
    //     selectorDateFrom,
    //     selectorDateTo,
    //     selectorAccountAction,
    //     selectorMarketAction,
    //     selectorDistributionChannelAction,
    //     selectorRegionAction,
    //     selectorCountryAction,
    //     selectorLanguageAction,
    //     selectorSummaryExpression,
    //     setValue
    // ]);

    // const selectorLabel = selectorContents?.["12029"];
    // const selectorRoyalty = selectorContents?.["12018"];
    // const selectorMin = selectorContents?.["12056"];
    // const selectorMax = selectorContents?.["12015"];
    // const selectorDateFrom = selectorContents?.["12071"];
    // const selectorDateTo = selectorContents?.["12072"];
    const selectorAccount = selectorContents?.["12023"] ?? [];
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);

    // ****************** END STORE ****************************

    //
    // const fetchHelperItems = async () => {
    //     if (!selectorContractSectionId) return;
    //
    //     console.log("fetching helper data");
    //
    //     const helperItems = await getHelperItems(selectorContractSectionId);
    //
    //     console.log("helper items");
    //     console.log(helperItems);
    //         setLineItemOptions(helperItems.filter(data => data.itemDp ===  12370));
    //     setSummaryItemOptions(helperItems.filter(data => data.itemDp ===  12401));
    //
    // };


    useEffect(() => {
        const fetchHelperItems = async () => {
            if (!selectorContractSectionId) return;

            console.log("fetching helper data");

            try {
                const helperItems =
                    await getHelperItems(selectorContractSectionId);

                console.log("helper items", helperItems);

                setLineItemOptions(
                    helperItems.filter(
                        data => data.itemDp ===  12108
                // data => data.itemDp ===  12370
                    )
                );

                setSummaryItemOptions(
                    helperItems.filter(
                        data => data.itemDp === 12404
                // data => data.itemDp === 12401
                    )
                );
            } catch (error) {
                console.error(
                    "Failed to fetch helper items",
                    error
                );
            }
        };

        fetchHelperItems();
    }, []);


    function onSubmit(data) {
        setSubmitting(true);

        const cleanedData = {
            ...data,

            "12406":
                data?.["12406"]
                    ?.map(item => item.value)
                    .filter(value =>
                        value !== "" &&
                        value !== null &&
                        value !== undefined
                    ) ?? [],

            "12407":
                data?.["12407"]
                    ?.map(item => item.value)
                    .filter(value =>
                        value !== "" &&
                        value !== null &&
                        value !== undefined
                    ) ?? []
        };

        console.log("Submitting form:", cleanedData);

        updateContractSectionContents(
            selectorContractSectionId,
            cleanedData
        )
            .then(res => {
                console.log("Updated contents:", data);
                console.log("Updated account data for this section:", selectorContractSectionId);
                return updateLineItem(selectorContractSectionId);
            })
            .then(data => {
                console.log("Updated account data:", data);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Data Submitted"}));
                // dispatchData(
                //     changeContractSection({
                //         csGridRefresh: true
                //     })
                // );
            })
            .catch(err => {
                console.error("Failed to update contents", err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Submit Failed"}));
            })
            .finally(() => {
                dispatchData(
                    changeContractSection({
                        csGridRefresh: true
                    }));

                setSubmitting(false);
            });
    }
    // function onSubmit(data) {
    //     setSubmitting(true)
    //     console.log("Submitting Form");
    //     console.log("here's my Form data");
    //     console.log({data})
    //     updateContractSectionContents(selectorContractSectionId, data)
    //         .then(res => {
    //             console.log("Updated contents:", res.data);
    //
    //             updateLineItem(selectorContractSectionId)
    //
    //                 .then(data => {
    //                     console.log("Updated line item:", data);
    //                     // const selectedSection = data.find(
    //                     //     item => item.id === selectorContractSectionId
    //                     // );
    //                     // dispatchData(changeContractSection({contents: selectedSection.contents }));
    //                     // console.log(labelValue); // "test 123"
    //             dispatchData(changeContractSection({csGridRefresh: true}));
    //                 })
    //
    //         })
    //         .catch(err => {
    //             console.error("Failed to update contents", err);
    //         });
    // };

    useEffect(() => {
        const savedLineItems = Array.isArray(selectorContents?.["12406"])
            ? selectorContents["12406"]
            : [];

        const savedSummaryItems = Array.isArray(selectorContents?.["12407"])
            ? selectorContents["12407"]
            : [];

        reset({
            ...selectorContents,

            "12406":
                savedLineItems.length > 0
                    ? savedLineItems.map(value => ({value}))
                    : [{value: ""}],

            "12407":
                savedSummaryItems.length > 0
                    ? savedSummaryItems.map(value => ({value}))
                    : [{value: ""}]
        });
    }, [
        selectorContractSectionId,
        selectorRawContents,
        reset
    ]);

    //
    // useEffect(() => {
    //     const savedLineItems = selectorContents?.["12406"] ?? [];
    //     const savedSummaryItems = selectorContents?.["12407"] ?? [];
    //
    //     reset({
    //         ...selectorContents,
    //
    //         "12406":
    //             savedLineItems.length > 0
    //                 ? savedLineItems.map(value => ({value}))
    //                 : [{value: ""}],
    //
    //         "12407":
    //             savedSummaryItems.length > 0
    //                 ? savedSummaryItems.map(value => ({value}))
    //                 : [{value: ""}]
    //     });
    // }, [selectorContractSectionId, selectorContents, reset]);

    // ****************** BEGIN CLOSE ***************************
    function closeQfDrawer() {
        dispatchData(changeContractSection({csGridRefresh: true}));
        dispatchData(changeContractDrilldownCS({QfDrawerState: false }));
    };
// ******************** END CLOSE ********************************



    // const didMountRef = React.useRef(false);

    const handleClearAll = React.useCallback(() => {
        setClearAll(prev => !prev);
        setSelectedParentItem(null);
        console.log("Clear All button clicked");
        dispatchData(changeHelper({
            content: null,
            contentClean: null,
            label: null,
            royalty: null,
            min: null,
            max: null,
            fromAmount: null,
            toAmount: null,
            dateFrom: null,
            dateTo: null,
            accountAction: "Includes",
            marketAction: "Includes",
            distributionChannelAction: "Includes",
            regionAction: "Includes",
            countryAction: "Includes",
            languageAction: "Includes",
            sumSign: "4563",
            distributionFee: null,
            overheadFee: null,
            distFeePct: null,
            overheadFeePct: null,
            maxFee: null,
            maxBasis: null,
        }));

        replaceLineItems([{value: ""}]);
        replaceSummaryItems([{value: ""}]);
        setValue("12574", "");
        setValue("12029", "");
        setValue("12597", "");
        setValue("12598", "");
        setValue("12018", "");
        setValue("12056", "");
        setValue("12015", "");
        setValue("12411", "");
        setValue("12412", "");
        setValue("12071", "");
        setValue("12072", "");
        setValue("11929", "");
        setValue("3664", "");
        setValue("3561", "");
        setValue("11644", "");
        setValue("12401", "");
        setValue("12600", "");
        setValue("12601", "");
        setValue("12602", "");
        setValue("12603", "");
        setValue("12604", "");
        
        setValue("12623", "");
        setValue("12624", []);
        setValue("12625", "");
        setValue("12626", []);
        setValue("12627", "");
        setValue("12628", "");
        setValue("12629", "");
        setValue("12630", "");
        setValue("12631", []);
        setValue("12632", "");
        setValue("12633", []);
        setValue("12634", "");

        setValue("12023", []);
        setValue("12025", []);
        setValue("12027", []);
        setValue("12020", []);
        setValue("12019", []);
        setValue("12022", []);
        setValue("12110", []);
        setValue("11936", []);
        setValue("12100", []);
        setValue("12106", []);
        setValue("12107", []);

        setValue("12074", "Includes");
        setValue("12077", "Includes");
        setValue("12080", "Includes");
        setValue("12083", "Includes");
        setValue("12086", "Includes");
        setValue("12089", "Includes");

        setValue("12476", "4563");
        // setValue("12074", "");
        // setValue("12077", "");
        // setValue("12080", "");
        // setValue("12083", "");
        // setValue("12086", "");
        // setValue("12089", "");

        console.log("Clear All button clicked");
    }, [
        dispatchData,
        replaceLineItems,
        replaceSummaryItems, setValue]);

    const labelFieldConfigByHelperMode = {
        "Account: Residuals": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Account: Other": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Account: Mapped Dist": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Account: Mapped Prod": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Overall Share": {
            selectorDataPointId: 12110,
            fieldName: "12110",
        },
        "Participant Gross Share": {
            selectorDataPointId: 11936,
            fieldName: "11936",
        },
        "Participant Net Share": {
            selectorDataPointId: 11936,
            fieldName: "11936",
        },
        "Adjusted Gross Receipts": {
            selectorDataPointId: 12100,
            fieldName: "12100",
        },
        "Gross Receipts": {
            selectorDataPointId: 12106,
            fieldName: "12106",
        },
        "Allowed Expenses": {
            selectorDataPointId: 12107,
            fieldName: "12107",
        },
           "Line Item": {
        selectorDataPointId: 12029,
            fieldName: "12029",
    },
        "Summary Item": {
            selectorDataPointId: 12405,
            fieldName: "12405",
        },
        "Distribution Fee": {
            selectorDataPointId: 12413,
            fieldName: "12413",
        },
        "Overhead Fee": {
            selectorDataPointId: 12417,
            fieldName: "12417",
        },
    };

    const labelFieldConfig =
        // labelFieldConfigByHelperMode[selectorHelperMode] ?? labelFieldConfigByHelperMode["L"];
        // Note: revisit this for account
    labelFieldConfigByHelperMode[selectorHelperMode] ?? labelFieldConfigByHelperMode["Line Item"];



    const didMountRef = React.useRef(false);

    useEffect(() => {
        console.log("clearForm changed in child:", clearForm);

        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }

        handleClearAll();
    }, [clearForm, handleClearAll]);
    // useEffect(() => {
    //     if (!didMountRef.current) {
    //         didMountRef.current = true;
    //         return;
    //     }
    //
    //
    // const handleClearAll = () => {
    //     // setClearAll(!clearAll);
    //     setClearAll(prev => !prev);
    //     setSelectedParentItem(null);
    //     setValue('proration', '');
    //     setValue('max', '');
    //     setValue('label', '');
    //     setValue("12029", "");
    //     setValue("12018", "");
    //     setValue("12056", "");
    //     setValue("12015", "");
    //     setValue("12071", "");
    //     setValue("12072", "");
    //     setValue("12074", "Includes");
    //     setValue("12077", "Includes");
    //     setValue("12080", "Includes");
    //     setValue("12083", "Includes");
    //     setValue("12086", "Includes");
    //     setValue("12089", "Includes");
    //     console.log("Clear All button clicked");
    // };
    //
    //
    //     handleClearAll();
    // }, [clearForm]);
    //
    // // useEffect(() => {
    // //     handleClearAll([]);
    // // }, [clearForm]);
    //
    // const handleParentItemChange = (event) => {
    //     setSelectedParentItem(event.target.value);
    //     console.log("This is for the selected Parent Item");
    //     console.log(event.target.value);
    // };
    //
    // useEffect(() => {
    // console.log("This is the selectorContents");
    // console.log(selectorContents);
    // //     console.log("This is the selectorAccount");
    // // console.log(selectorAccount);
    //
    // }, []);


    const [showAccount, setShowAccount] = useState(true);
    const [selectedExpression, setSelectedExpression] = useState();

    const [accountDropdown, setAccountDropdown] = useState([]);


    // const fetchAccountsForDropdowns = () =>
    //     getAccountHierarchy(selectorContractId)
    //
    //         .then(data => {
    //             console.log(data);
    //             // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
    //             setAccountDropdown(data);
    //             console.log("Accounts data");
    //             console.log("Queried contract_id = ", selectorContractId);
    //             console.log(data);
    //         })
    const fetchAccountsForDropdowns = () =>
        getAccountHierarchy(selectorContractId)
            .then(data => {
                setAccountDropdown([
                    {
                        cdpId: null,
                        expressionText: "",
                        accountName: "",
                        hierarchyLevel: 0
                    },
                    ...data
                ]);
            });
    useEffect(() => {
        console.log("This is for the accounts dropdown...");
        fetchAccountsForDropdowns();
    }, []);



    const handleAccountChange = (fieldName, newExpression) => {
        setSelectedExpression(newExpression);
        setValue(fieldName, newExpression);
        dispatchData(changeHelper({distributionFee: fieldName === '12597' ? newExpression : null , overheadFee: fieldName === '12598' ? newExpression : null}));
    };

    const handleMultiChange = (fieldName, newValues) => {

        // Map fieldName to Redux property
        const fieldMap = {
            '12597': 'distributionFeeMulti',
            '12598': 'overheadFeeMulti',
            '12624': 'maxResultLimiter',
            '12626': 'maxBasisLimiter',
            '12631': 'overheadMaxFeeLimiter',
            '12633': 'overheadMaxBasisLimiter'
        };

        const reduxField = fieldMap[fieldName];

        // Exit if fieldName is not recognized
        if (!reduxField) return;

        // Update only the corresponding Redux property
        dispatchData(changeHelper({
            [reduxField]: newValues
        }));

        // Build expression for submission
        const expression = newValues.join(" + ");

        // Store expression in React Hook Form
        setValue(fieldName, expression, {
            shouldDirty: true,
            shouldValidate: true
        });
    };
    //
    // const handleAccountChangeMulti = (fieldName, newValues) => {
    //
    //     // Keep array for the Select
    //     dispatchData(changeHelper({
    //         distributionFeeMulti: fieldName === '12597' ?  newValues : [],
    //         overheadFeeMulti: fieldName === '12598' ? newValues : []
    //     }));
    //
    //     // Build expression for submission
    //     const expression = newValues.join(" + ");
    //
    //     // Store the expression in React Hook Form
    //     setValue(fieldName, expression);
    // };
    //
    //
    //
    // const handleResultLimiterChangeMulti = (fieldName, newValues) => {
    //     // Keep array for the Select
    //     dispatchData(changeHelper({
    //         maxResultLimiter: fieldName === '12624' ?  newValues : []
    //     }));
    //
    //     // Build expression for submission
    //     const expression = newValues.join(" + ");
    //
    //     // Store the expression in React Hook Form
    //     setValue(fieldName, expression);
    // };
    //
    //
    //
    // const handleBasisLimiterChangeMulti = (fieldName, newValues) => {
    //     // Keep array for the Select
    //     dispatchData(changeHelper({
    //         maxBasisLimiter: fieldName === '12626' ?  newValues : []
    //     }));
    //
    //     // Build expression for submission
    //     const expression = newValues.join(" + ");
    //
    //     // Store the expression in React Hook Form
    //     setValue(fieldName, expression);
    // };
    //
    //
    //
    // const handleOverheadFeeLimiterChangeMulti = (fieldName, newValues) => {
    //     // Keep array for the Select
    //     dispatchData(changeHelper({
    //         overheadMaxFeeLimiter: fieldName === '12631' ?  newValues : []
    //     }));
    //
    //     // Build expression for submission
    //     const expression = newValues.join(" + ");
    //
    //     // Store the expression in React Hook Form
    //     setValue(fieldName, expression);
    // };
    //
    //
    //
    // const handleOverheadBasisLimiterChangeMulti = (fieldName, newValues) => {
    //     // Keep array for the Select
    //     dispatchData(changeHelper({
    //         overheadMaxBasisLimiter: fieldName === '12633' ?  newValues : []
    //     }));
    //
    //     // Build expression for submission
    //     const expression = newValues.join(" + ");
    //
    //     // Store the expression in React Hook Form
    //     setValue(fieldName, expression);
    // };



    const handleGrossesChange = (fieldName, newExpression) => {
        // setSelectedExpression(newExpression);
        setValue(fieldName, newExpression);
        dispatchData(changeHelper({grossesMapping: newExpression}));
    };



    const handleExpensesChange = (fieldName, newExpression) => {
        // setSelectedExpression(newExpression);
        setValue(fieldName, newExpression);
        dispatchData(changeHelper({expensesMapping: newExpression}));
    };


    const handleAdjGrossChange = (fieldName, newExpression) => {
        // setSelectedExpression(newExpression);
        setValue(fieldName, newExpression);
        dispatchData(changeHelper({adjGrossMapping: newExpression}));
    };




    const handleBonusChange = (fieldName, newExpression) => {
        // setSelectedExpression(newExpression);
        setValue(fieldName, newExpression);
        dispatchData(changeHelper({bonusMapping: newExpression}));
    };








    // ****************** BEGIN RETURN ****************************

    return (

        <form
            id="lineItemForm"
            onSubmit={handleSubmit((data)=>        onSubmit(data))}

        >

            <Box
                sx={{ width: 1000 , height: 300, pl: 5}}
                role="presentation"
            >

                <br/>



<Stack direction="row" spacing={4}     alignItems="center" >

</Stack>

{/*-- ************************************************************************************************************************/}
{/*-- ***************************************************   ROW 1   **********************************************************/}
{/*-- ************************************************************************************************************************/}

                <Stack direction="row" spacing={8}     alignItems="center" >


{/*-- ***************************************************   LABEL   **********************************************************/}

                    {selectorHelperMode !== "Bonus" &&
                    <DynamicCdpvValueField
                        selectorContext={"label"}
                        selectorLabel={ "Label"}
                        selectorDataType={'TEXT'}
                        selectorValue={selectorLabel}
                        selectorDataPointId={labelFieldConfig.selectorDataPointId}
                        fieldName={labelFieldConfig.fieldName}
                        setValue={setValue}
                    />}

{/*-- ***************************************************   %   **********************************************************/}

                    { (selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Account: Other") &&
                        <DynamicCdpvValueField
                            selectorContext={"royalty"}
                            selectorLabel={ "Royalty %"}
                            selectorDataType={'PERCENTAGE'}
                            selectorValue={selectorRoyalty}
                            selectorDataPointId={12018}
                            fieldName = "12018"
                            setValue={setValue}
                        />
                    }


                    {selectorHelperMode === "Participant Gross Share" &&
                        <DynamicCdpvValueField
                            selectorContext={"share"}
                            selectorLabel={ "Share Pct"}
                            selectorDataType={'PERCENTAGE'}
                            selectorValue={selectorShare}
                            selectorDataPointId={11929}
                            fieldName = "11929"
                            setValue={setValue}
                        />
                    }

                    {selectorHelperMode === "Participant Net Share" &&
                        <DynamicCdpvValueField
                            selectorContext={"share"}
                            selectorLabel={ "Share Pct"}
                            selectorDataType={'PERCENTAGE'}
                            selectorValue={selectorNetShare}
                            selectorDataPointId={3664}
                            fieldName = "3664"
                            setValue={setValue}
                        />
                    }

                    {selectorHelperMode === "Distribution Fee" &&
                        <DynamicCdpvValueField
                            selectorContext={"distributionFee"}
                            selectorLabel={ "Fee %"}
                            selectorDataType={'PERCENTAGE'}
                            selectorValue={selectorDistFeePct}
                            selectorDataPointId={3561}
                            fieldName = "3561"
                            setValue={setValue}
                        />
                    }



{/*-- ***************************************************   PADDING   **********************************************************/}

                    {(selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Line Item" || selectorHelperMode === "Cost Item" ) &&
                    <Box sx={{width: 40}}/>
                    }


{/*-- ***************************************************   PLUS MINUS   **********************************************************/}


                    {(selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Mapped Dist" ||  selectorHelperMode === "Account: Residuals" || selectorHelperMode === "Line Item" || selectorHelperMode === "Cost Item" ) &&
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography>
                            Sum as...
                        </Typography>

                        <Controller
                            name="12476"
                            control={control}
                            defaultValue={selectorSumSign ?? "4563"}
                            render={({ field }) => (
                                <RadioGroup
                                    {...field}
                                    row
                                >
                                    <FormControlLabel
                                        value="4563"
                                        control={<Radio />}
                                        label="+"
                                    />
                                    <FormControlLabel
                                        value="4564"
                                        control={<Radio />}
                                        label="-"
                                    />
                                </RadioGroup>
                            )}
                        />

                    </Stack>
                    }


 {/*-- ***************************************************   MAPPING   **********************************************************/}



                    {selectorHelperMode === "Distribution Fee"  &&
                        <Stack direction="row" spacing={0}     alignItems="center" >

                            <div>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                >
                                    <InputLabel>Fee Basis</InputLabel>

                                    <Select
                                        id="dist_fee_multi_id"
                                        multiple
                                        value={selectorDistributionFeeMulti ?? []}
                                        renderValue={(selected) =>
                                            selected?.length > 0
                                                ? "(click to view selected values)"
                                                : ""
                                        }
                                        label="Basis"
                                        onChange={(event) => {
                                            const newValues = event.target.value;

                                            if (newValues.includes("__CLEAR_ALL__")) {
                                                handleMultiChange("12597", []);
                                            } else {
                                                handleMultiChange("12597", newValues);
                                            }
                                        }}
                                    >
                                        <MenuItem
                                            value="__CLEAR_ALL__"
                                            disabled={(selectorDistributionFeeMulti ?? []).length === 0}
                                        >
                                            <ListItemText
                                                primary="Clear All"
                                                primaryTypographyProps={{
                                                    fontWeight: "bold"
                                                }}
                                            />
                                        </MenuItem>

                                        <Divider />

                                        {accountDropdown.map((accountItem) => {
                                            const value = `^12531^${accountItem.expressionText}`;

                                            return (
                                                <MenuItem
                                                    key={accountItem.cdpId}
                                                    value={value}
                                                    sx={{
                                                        pl: accountItem.hierarchyLevel * 2
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={(selectorDistributionFeeMulti ?? []).includes(value)}
                                                    />

                                                    <ListItemText
                                                        primary={accountItem.accountName}
                                                        primaryTypographyProps={{
                                                            fontWeight:
                                                                accountItem.hierarchyLevel === 1
                                                                    ? "bold"
                                                                    : "normal"
                                                        }}
                                                    />
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>



                                    {/*<FormHelperText id="value_helper">select the account to which you want to map this data point</FormHelperText>*/}
                                </FormControl>
                            </div>
                        </Stack>
                    }
                    {selectorHelperMode === "Overhead Fee"  &&

                        <div>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                >
                    <InputLabel>Fee Basis</InputLabel>

                    <Select
                        id="overhead_fee_multi_id"
                        multiple
                        value={selectorOverheadFeeMulti ?? []}
                        renderValue={(selected) =>
                            selected?.length > 0
                                ? "(click to view selected values)"
                                : ""
                        }
                        label="Basis"
                        onChange={(event) => {
                            const newValues = event.target.value;

                            if (newValues.includes("__CLEAR_ALL__")) {
                                handleMultiChange("12598", []);
                            } else {
                                handleMultiChange("12598", newValues);
                            }
                        }}
                    >
                        <MenuItem
                            value="__CLEAR_ALL__"
                            disabled={(selectorOverheadFeeMulti ?? []).length === 0}
                        >
                            <ListItemText
                                primary="Clear All"
                                primaryTypographyProps={{
                                    fontWeight: "bold"
                                }}
                            />
                        </MenuItem>

                        <Divider />

                        {accountDropdown.map((accountItem) => {
                            const value = `^12546^${accountItem.expressionText}`;

                            return (
                                <MenuItem
                                    key={accountItem.cdpId}
                                    value={value}
                                    sx={{
                                        pl: accountItem.hierarchyLevel * 2
                                    }}
                                >
                                    <Checkbox
                                        checked={(selectorOverheadFeeMulti ?? []).includes(value)}
                                    />

                                    <ListItemText
                                        primary={accountItem.accountName}
                                        primaryTypographyProps={{
                                            fontWeight:
                                                accountItem.hierarchyLevel === 1
                                                    ? "bold"
                                                    : "normal"
                                        }}
                                    />
                                </MenuItem>
                            );
                        })}
                    </Select>

                </FormControl>
            </div>
                    }
                </Stack>



                {selectorHelperMode === 'Bonus' &&
                    <div>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                        >
                            <InputLabel>Bonus Basis</InputLabel>
                            <Select
                                id="gross_id"
                                // value={selectedExpression ?? ""}
                                value={selectorBonusMapping ?? ""}
                                label="Bonus"
                                onChange={(event) =>
                                    handleBonusChange("12610", event.target.value)
                                }
                            >
                                {accountDropdown.map((accountItem) =>
                                    <MenuItem
                                        value={`^12606^${accountItem.expressionText}`}
                                        sx={{
                                            fontWeight: accountItem.hierarchyLevel === 1 ? 'bold' : 'normal',
                                            pl: accountItem.hierarchyLevel * 2 }}
                                    >{accountItem.accountName}</MenuItem>
                                )

                                }
                            </Select>
                            {/*<FormHelperText id="value_helper">select the account to which you want to map this data point</FormHelperText>*/}
                        </FormControl>
                    </div>}
                {selectorHelperMode !== "Bonus" &&
                    <div>
                <br/>
                <br/>
                    </div>}


{/*-- ************************************************************************************************************************/}
{/*-- ***************************************************   ROW 2   **********************************************************/}
{/*-- ************************************************************************************************************************/}

{/*-- ***************************************************  MAX OUT  **********************************************************/}

                {
                    (selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Other" || selectorHelperMode === "Account: Residuals" ) &&
                <Stack direction="row" spacing={3}     alignItems="center" >

                    <Box sx={{width: 150}}>

                    <Typography>{ selectorHelperMode  === "Distribution Fee" ? "Max Fee:" : "Max Amount:"} </Typography>
                    </Box>

                    <DynamicCdpvValueField
                        selectorContext={"maxAmount"}
                        selectorLabel={ "Dollar Max"}
                        selectorDataType={'DOLLARS'}
                        selectorValue={selectorHelperMode  === "Distribution Fee" ? selectorMaxFee : selectorMaxAmount}
                        selectorDataPointId={selectorHelperMode  === "Distribution Fee" ? 12600 : 12623}
                        fieldName = {selectorHelperMode  === "Distribution Fee" ? "12600" : "12623"}
                        setValue={setValue}
                    />


                    <Typography sx={{pr: 6}}>Or</Typography>


                        <DynamicCdpvValueField
                            selectorContext={"maxResultPct"}
                            selectorLabel={ "Percentage"}
                            selectorDataType={'PERCENTAGE'}
                            selectorValue={selectorMaxResultPct}
                            selectorDataPointId={12625}
                            fieldName = "12625"
                            setValue={setValue}
                        />

                    <Typography>of</Typography>

                    <div>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                        >
                            <InputLabel>Account</InputLabel>

                            <Select
                                id="maxResultLimiter"
                                multiple
                                value={selectorMaxResultLimiter ?? []}
                                renderValue={(selected) =>
                                    selected?.length > 0
                                        ? "(click to view selected values)"
                                        : ""
                                }
                                label="Basis"
                                onChange={(event) => {
                                    const newValues = event.target.value;

                                    if (newValues.includes("__CLEAR_ALL__")) {
                                        handleMultiChange("12624", []);
                                    } else {
                                        handleMultiChange("12624", newValues);
                                    }
                                }}
                            >
                                <MenuItem
                                    value="__CLEAR_ALL__"
                                    disabled={(selectorMaxResultLimiter ?? []).length === 0}
                                >
                                    <ListItemText
                                        primary="Clear All"
                                        primaryTypographyProps={{
                                            fontWeight: "bold"
                                        }}
                                    />
                                </MenuItem>

                                <Divider />

                                {accountDropdown.map((accountItem) => {
                                    const value = `^12571^${accountItem.expressionText}`;

                                    return (
                                        <MenuItem
                                            key={accountItem.cdpId}
                                            value={value}
                                            sx={{
                                                pl: accountItem.hierarchyLevel * 2
                                            }}
                                        >
                                            <Checkbox
                                                checked={(selectorMaxResultLimiter ?? []).includes(value)}
                                            />

                                            <ListItemText
                                                primary={accountItem.accountName}
                                                primaryTypographyProps={{
                                                    fontWeight:
                                                        accountItem.hierarchyLevel === 1
                                                            ? "bold"
                                                            : "normal"
                                                }}
                                            />
                                        </MenuItem>
                                    );
                                })}
                            </Select>

                        </FormControl>
                    </div>

                </Stack>
                }

 {/*-- ***************************************************  NET SHARE   **********************************************************/}
                {
                    (selectorHelperMode === "Participant Net Share") &&
                    <div>
                    <Stack direction="row" spacing={8}     alignItems="center" >

                        <DynamicCdpvValueField
                            selectorContext={"fromAmount"}
                            selectorLabel={ "Net Amount From"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorFrom}
                            selectorDataPointId={12411}
                            fieldName = "12411"
                            setValue={setValue}
                        />
                        <DynamicCdpvValueField
                            selectorContext={"toAmount"}
                            selectorLabel={ "Net Amount To"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorTo}
                            selectorDataPointId={12412}
                            fieldName = "12412"
                            setValue={setValue}
                        />
                        <DynamicCdpvValueField
                            selectorContext={"maxNet"}
                            selectorLabel={ "Maximum Net Amount"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorMaxNet}
                            selectorDataPointId={12602}
                            fieldName = "12602"
                            setValue={setValue}
                        />
                        <DynamicCdpvValueField
                            selectorContext={"maxShare"}
                            selectorLabel={ "Maximum Share"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorMaxShare}
                            selectorDataPointId={12603}
                            fieldName = "12603"
                            setValue={setValue}
                        />
                    </Stack>

                    </div>
                    }


{/*-- ***************************************************  GROSS SHARE   **********************************************************/}

                {
                    (selectorHelperMode === "Participant Gross Share" ) &&
                    <Stack direction="row" spacing={8}     alignItems="center" >

                        <DynamicCdpvValueField
                            selectorContext={"fromAmount"}
                            selectorLabel={ "From Amount"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorFrom}
                            selectorDataPointId={12411}
                            fieldName = "12411"
                            setValue={setValue}
                        />
                        <DynamicCdpvValueField
                            selectorContext={"toAmount"}
                            selectorLabel={ "To Amount"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorTo}
                            selectorDataPointId={12412}
                            fieldName = "12412"
                            setValue={setValue}
                        />
                        <DynamicCdpvValueField
                            selectorContext={"maxGross"}
                            selectorLabel={ "Maximum Adj Gross"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorMaxGross}
                            selectorDataPointId={12604}
                            fieldName = "12604"
                            setValue={setValue}
                        />
                        <DynamicCdpvValueField
                            selectorContext={"maxShare"}
                            selectorLabel={ "Maximum Share"}
                            selectorDataType={'DOLLARS'}
                            selectorValue={selectorMaxShare}
                            selectorDataPointId={12603}
                            fieldName = "12603"
                            setValue={setValue}
                        />
                    </Stack>
                }

                {
                    (selectorHelperMode !== "Participant Net Share" && selectorHelperMode !== "Bonus" ) &&
                <Stack direction="row" spacing={8}     alignItems="center" >

                    { (selectorHelperMode === "Distribution Fee" || selectorHelperMode === "Overhead Fee") &&
                        <Stack direction="row" spacing={8}     alignItems="center" >
                        <DynamicCdpvValueField
                        selectorContext={"maxFee"}
                        selectorLabel={ "Maximum Fee"}
                        selectorDataType={'DOLLARS'}
                        selectorValue={selectorMaxFee}
                        selectorDataPointId={12600}
                        fieldName = "12600"
                        setValue={setValue}
                    />

                    <DynamicCdpvValueField
                        selectorContext={"maxBasis"}
                        selectorLabel={ "Maximum Basis"}
                        selectorDataType={'DOLLARS'}
                        selectorValue={selectorMaxBasis}
                        selectorDataPointId={12601}
                        fieldName = "12601"
                        setValue={setValue}
                    />

                        </Stack>
                    }

                    {/*{ (selectorHelperMode !== "Cost Item"  && selectorHelperMode !== "Distribution Fee" && selectorHelperMode !== "Overhead Fee") &&*/}
                    {/*    <DynamicCdpvValueField*/}
                    {/*    selectorContext={"min"}*/}
                    {/*    selectorLabel={ "Minimum"}*/}
                    {/*    selectorDataType={'DOLLARS'}*/}
                    {/*    selectorValue={selectorMin}*/}
                    {/*    selectorDataPointId={12056}*/}
                    {/*    fieldName = "12056"*/}
                    {/*    setValue={setValue}*/}
                    {/*/>*/}
                    {/*}*/}
                    {/*{( selectorHelperMode !== "Distribution Fee" && selectorHelperMode !== "Overhead Fee") &&*/}
                    {/*<DynamicCdpvValueField*/}
                    {/*    selectorContext={"max"}*/}
                    {/*    selectorLabel={ "Maximum"}*/}
                    {/*    selectorDataType={'DOLLARS'}*/}
                    {/*    selectorValue={selectorMax}*/}
                    {/*    selectorDataPointId={12015}*/}
                    {/*    fieldName = "12015"*/}
                    {/*    setValue={setValue}*/}
                    {/*/>}*/}
                    {(selectorHelperMode === 'Gross Share')  &&
                        <DynamicCdpvValueField
                        selectorContext={"dateFrom"}
                        selectorLabel={ "Date From"}
                        selectorDataType={'DATE'}
                        selectorValue={selectorDateFrom}
                        selectorDataPointId={12071}
                        fieldName = "12071"
                        setValue={setValue}
                    />}
                    {(selectorHelperMode === 'Gross Share')  &&
                        <DynamicCdpvValueField
                        selectorContext={"dateTo"}
                        selectorSummaryExpression={ "Date To"}
                        selectorDataType={'DATE'}
                        selectorValue={selectorDateTo}
                        selectorDataPointId={12072}
                        fieldName = "12072"
                        setValue={setValue}
                    />
                    }
                </Stack>
                }







                {/*{selectorHelperMode === "Summary Item" && (*/}
                {/*    <Box>*/}
                {/*        <br />*/}
                {/*        <br />*/}
                {/*        <Typography sx={{fontWeight: 700}}>*/}
                {/*            Sum of ...*/}
                {/*        </Typography>*/}

                {/*        <br />*/}

                {/*        <Stack*/}
                {/*            direction="row"*/}
                {/*            spacing={8}*/}
                {/*            alignItems="flex-start"*/}
                {/*        >*/}
                {/*            /!* Line Items — data point 12406 *!/*/}
                {/*            <Box sx={{width: 350}}>*/}
                {/*                /!*<Typography sx={{fontWeight: 700, mb: 1}}>*!/*/}
                {/*                /!*    Line Items*!/*/}
                {/*                /!*</Typography>*!/*/}

                {/*                <Stack spacing={2}>*/}
                {/*                    {lineItemFields.map((field, index) => (*/}
                {/*                        <Stack*/}
                {/*                            key={field.itemNumber}*/}
                {/*                            direction="row"*/}
                {/*                            spacing={1}*/}
                {/*                            alignItems="center"*/}
                {/*                        >*/}
                {/*                            <Controller*/}
                {/*                                name={`12406.${index}.value`}*/}
                {/*                                control={control}*/}
                {/*                                render={({field: controllerField}) => (*/}
                {/*                                    <FormControl*/}
                {/*                                        variant="standard"*/}
                {/*                                        fullWidth*/}
                {/*                                    >*/}
                {/*                                        <InputLabel>*/}
                {/*                                            Account {index + 1}*/}
                {/*                                            /!*Line Item {index + 1}*!/*/}
                {/*                                        </InputLabel>*/}

                {/*                                        <Select*/}
                {/*                                            {...controllerField}*/}
                {/*                                            label={`Account ${index + 1}`}*/}
                {/*                                            // label={`Line Item ${index + 1}`}*/}
                {/*                                        >*/}
                {/*                                            <MenuItem value="">*/}
                {/*                                                <em>None</em>*/}
                {/*                                            </MenuItem>*/}

                {/*                                            {lineItemOptions.map(option => (*/}
                {/*                                                <MenuItem*/}
                {/*                                                    key={option.itemNumber}*/}
                {/*                                                    value={option.itemNumber}*/}
                {/*                                                >*/}
                {/*                                                    {option.itemLabel} ({option.itemNumber})*/}
                {/*                                                </MenuItem>*/}
                {/*                                            ))}*/}
                {/*                                        </Select>*/}
                {/*                                    </FormControl>*/}
                {/*                                )}*/}
                {/*                            />*/}

                {/*                            <Button*/}
                {/*                                type="button"*/}
                {/*                                onClick={() => removeLineItem(index)}*/}
                {/*                                disabled={lineItemFields.length === 1}*/}
                {/*                            >*/}
                {/*                                Remove*/}
                {/*                            </Button>*/}
                {/*                        </Stack>*/}
                {/*                    ))}*/}
                {/*                </Stack>*/}

                {/*                <Button*/}
                {/*                    type="button"*/}
                {/*                    sx={{mt: 2}}*/}
                {/*                    onClick={() => appendLineItem({value: ""})}*/}
                {/*                >*/}
                {/*                    Add Another Line Item*/}
                {/*                </Button>*/}
                {/*            </Box>*/}

                {/*            /!* Summary Items — data point 12407 *!/*/}
                {/*            <Box sx={{width: 350}}>*/}
                {/*                /!*<Typography sx={{fontWeight: 700, mb: 1}}>*!/*/}
                {/*                /!*    Summary Items*!/*/}
                {/*                /!*</Typography>*!/*/}

                {/*                <Stack spacing={2}>*/}
                {/*                    {summaryItemFields.map((field, index) => (*/}
                {/*                        <Stack*/}
                {/*                            key={field.itemNumber}*/}
                {/*                            direction="row"*/}
                {/*                            spacing={1}*/}
                {/*                            alignItems="center"*/}
                {/*                        >*/}
                {/*                            <Controller*/}
                {/*                                name={`12407.${index}.value`}*/}
                {/*                                control={control}*/}
                {/*                                render={({field: controllerField}) => (*/}
                {/*                                    <FormControl*/}
                {/*                                        variant="standard"*/}
                {/*                                        fullWidth*/}
                {/*                                    >*/}
                {/*                                        <InputLabel>*/}
                {/*                                            Summary Item {index + 1}*/}
                {/*                                        </InputLabel>*/}

                {/*                                        <Select*/}
                {/*                                            {...controllerField}*/}
                {/*                                            label={`Summary Item ${index + 1}`}*/}
                {/*                                        >*/}
                {/*                                            <MenuItem value="">*/}
                {/*                                                <em>None</em>*/}
                {/*                                            </MenuItem>*/}

                {/*                                            {summaryItemOptions.map(option => (*/}
                {/*                                                <MenuItem*/}
                {/*                                                    key={option.itemNumber}*/}
                {/*                                                    value={option.itemNumber}*/}
                {/*                                                >*/}
                {/*                                                    {option.itemLabel} ({option.itemNumber})*/}
                {/*                                                </MenuItem>*/}
                {/*                                            ))}*/}
                {/*                                        </Select>*/}
                {/*                                    </FormControl>*/}
                {/*                                )}*/}
                {/*                            />*/}

                {/*                            <Button*/}
                {/*                                type="button"*/}
                {/*                                onClick={() => removeSummaryItem(index)}*/}
                {/*                                disabled={summaryItemFields.length === 1}*/}
                {/*                            >*/}
                {/*                                Remove*/}
                {/*                            </Button>*/}
                {/*                        </Stack>*/}
                {/*                    ))}*/}
                {/*                </Stack>*/}

                {/*                <Button*/}
                {/*                    type="button"*/}
                {/*                    sx={{mt: 2}}*/}
                {/*                    onClick={() => appendSummaryItem({value: ""})}*/}
                {/*                >*/}
                {/*                    Add Another Summary Item*/}
                {/*                </Button>*/}
                {/*            </Box>*/}
                {/*        </Stack>*/}
                {/*    </Box>*/}
                {/*)}*/}


{/*-- ************************************************************************************************************************/}
{/*-- ***************************************************   ROW 3   **********************************************************/}
{/*-- ************************************************************************************************************************/}
                {selectorHelperMode !== "Bonus" &&
                    <div>
                <br/>
                <br/>
                    </div>
                }


                {/*-- ***************************************************  MAX IN  **********************************************************/}

                {
                    (selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Other"  || selectorHelperMode === "Account: Residuals") &&
                <Stack direction="row" spacing={3}     alignItems="center" >

                    <Box sx={{width: 150}}>
                        <Typography>Max Basis:</Typography>
                    </Box>

                    <DynamicCdpvValueField
                        selectorContext={"maxBasis"}
                        selectorLabel={ "Dollar Max"}
                        selectorDataType={'DOLLARS'}
                        selectorValue={selectorMaxBasis}
                        selectorDataPointId={12601}
                        fieldName = "12601"
                        setValue={setValue}
                    />

                    <Typography sx={{pr: 6}}>Or</Typography>


                    <DynamicCdpvValueField
                        selectorContext={"maxBasisPct"}
                        selectorLabel={ "Percentage"}
                        selectorDataType={'PERCENTAGE'}
                        selectorValue={selectorMaxBasisPct}
                        selectorDataPointId={12627}
                        fieldName = "12627"
                        setValue={setValue}
                    />

                    <Typography>of</Typography>

                    <div>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                        >
                            <InputLabel>Account</InputLabel>

                            <Select
                                id="maxResultLimiter"
                                multiple
                                value={selectorMaxBasisLimiter ?? []}
                                renderValue={(selected) =>
                                    selected?.length > 0
                                        ? "(click to view selected values)"
                                        : ""
                                }
                                label="Basis"
                                onChange={(event) => {
                                    const newValues = event.target.value;

                                    if (newValues.includes("__CLEAR_ALL__")) {
                                        handleMultiChange("12626", []);
                                    } else {
                                        handleMultiChange("12626", newValues);
                                    }
                                }}
                            >
                                <MenuItem
                                    value="__CLEAR_ALL__"
                                    disabled={(selectorMaxBasisLimiter ?? []).length === 0}
                                >
                                    <ListItemText
                                        primary="Clear All"
                                        primaryTypographyProps={{
                                            fontWeight: "bold"
                                        }}
                                    />
                                </MenuItem>

                                <Divider />

                                {accountDropdown.map((accountItem) => {
                                    const value = `^12571^${accountItem.expressionText}`;

                                    return (
                                        <MenuItem
                                            key={accountItem.cdpId}
                                            value={value}
                                            sx={{
                                                pl: accountItem.hierarchyLevel * 2
                                            }}
                                        >
                                            <Checkbox
                                                checked={(selectorMaxBasisLimiter ?? []).includes(value)}
                                            />

                                            <ListItemText
                                                primary={accountItem.accountName}
                                                primaryTypographyProps={{
                                                    fontWeight:
                                                        accountItem.hierarchyLevel === 1
                                                            ? "bold"
                                                            : "normal"
                                                }}
                                            />
                                        </MenuItem>
                                    );
                                })}
                            </Select>

                        </FormControl>
                    </div>

                </Stack>
                }

                {
                    (selectorHelperMode === "Participant Net Share") &&
                    <div>

                        <Stack direction="row" spacing={8}     alignItems="center" >

                            <div>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                >
                                    <InputLabel>Grosses Mapping</InputLabel>
                                    <Select
                                        id="gross_id"
                                        // value={selectedExpression ?? ""}
                                        value={selectorGrossesMapping ?? ""}
                                        label="Gross"
                                        onChange={(event) =>
                                            handleGrossesChange("12595", event.target.value)
                                        }
                                    >
                                        {accountDropdown.map((accountItem) =>
                                            <MenuItem
                                                value={`^12571^${accountItem.expressionText}`}
                                                sx={{
                                                    fontWeight: accountItem.hierarchyLevel === 1 ? 'bold' : 'normal',
                                                    pl: accountItem.hierarchyLevel * 2 }}
                                            >{accountItem.accountName}</MenuItem>
                                        )

                                        }
                                    </Select>
                                    {/*<FormHelperText id="value_helper">select the account to which you want to map this data point</FormHelperText>*/}
                                </FormControl>
                            </div>

                            <div>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                >
                                    <InputLabel>Expenses Mapping</InputLabel>
                                    <Select
                                        id="account_id"
                                        // value={selectedExpression ?? ""}
                                        value={selectorExpensesMapping ?? ""}
                                        label="Expenses"
                                        onChange={(event) =>
                                            handleExpensesChange("12596", event.target.value)
                                        }
                                    >
                                        {accountDropdown.map((accountItem) =>
                                            <MenuItem
                                                value={`^12571^${accountItem.expressionText}`}
                                                sx={{
                                                    fontWeight: accountItem.hierarchyLevel === 1 ? 'bold' : 'normal',
                                                    pl: accountItem.hierarchyLevel * 2 }}
                                            >{accountItem.accountName}</MenuItem>
                                        )

                                        }
                                    </Select>
                                    {/*<FormHelperText id="value_helper">select the account to which you want to map this data point</FormHelperText>*/}
                                </FormControl>
                            </div>

                        </Stack>
                    </div>
                }


                {
                    (selectorHelperMode === "Participant Gross Share") &&
                    <Stack direction="row" spacing={8}     alignItems="center" >
                    <div>

                        <Stack direction="row" spacing={8}     alignItems="center" >


                            <div>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                >
                                    <InputLabel>Adjusted Gross Mapping</InputLabel>
                                    <Select
                                        id="account_id"
                                        // value={selectedExpression ?? ""}
                                        value={selectorAdjGrossMapping ?? ""}
                                        label="AdjGross"
                                        onChange={(event) =>
                                            handleAdjGrossChange("12599", event.target.value)
                                        }
                                    >
                                        {accountDropdown.map((accountItem) =>
                                            <MenuItem
                                                value={`^12478^${accountItem.expressionText}`}
                                                sx={{
                                                    fontWeight: accountItem.hierarchyLevel === 1 ? 'bold' : 'normal',
                                                    pl: accountItem.hierarchyLevel * 2 }}
                                            >{accountItem.accountName}</MenuItem>
                                        )

                                        }
                                    </Select>
                                    {/*<FormHelperText id="value_helper">select the account to which you want to map this data point</FormHelperText>*/}
                                </FormControl>
                            </div>

                        </Stack>
                    </div>


                        {/*-- ***************************************************   GROSS SHARE DATE FROM DATE TO **********************************************************/}


                            <DynamicCdpvValueField
                                selectorContext={"dateFrom"}
                                selectorLabel={ "Period End From"}
                                selectorDataType={'DATE'}
                                selectorValue={selectorDateFrom}
                                selectorDataPointId={12071}
                                fieldName = "12071"
                                setValue={setValue}
                            />

                            <DynamicCdpvValueField
                                selectorContext={"dateTo"}
                                selectorLabel={ "Period End To"}
                                selectorDataType={'DATE'}
                                selectorValue={selectorDateTo}
                                selectorDataPointId={12072}
                                fieldName = "12072"
                                setValue={setValue}
                            />
                    </Stack>

                        }

{/*-- ************************************************************************************************************************/}
{/*-- ***************************************************   OVERHEAD FEES ****************************************************/}
{/*-- ************************************************************************************************************************/}

                { (selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Account: Other"  || selectorHelperMode === "Account: Residuals") &&
                    <div>
<br/>
                <Box>
                    <Box
                        onClick={() => setOverheadOpen(prev => !prev)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        <IconButton
                            component="span"
                            size="small"
                            tabIndex={-1}
                            sx={{ pointerEvents: "none" }}
                        >
                            <ChevronRightIcon
                                sx={{
                                    transform: overheadOpen
                                        ? "rotate(90deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 0.2s"
                                }}
                            />
                        </IconButton>

                        <Typography fontWeight="bold">
                            Overhead Fee
                        </Typography>
                    </Box>

                    <Collapse in={overheadOpen}>
                        <Box sx={{ pl: 4, pt: 2 }}>
                            <Stack spacing={2}>


{/*-- ************************************************************************************************************************/}
{/*-- ******************************************** OVERHEAD ROW 1   **********************************************************/}
{/*-- ************************************************************************************************************************/}


                                <div>
                                    <Stack direction="row" spacing={12}     alignItems="center" >
                                    <DynamicCdpvValueField
                                        selectorContext={"overheadFee"}
                                        selectorLabel={ "Fee %"}
                                        selectorDataType={'PERCENTAGE'}
                                        selectorValue={selectorOverheadFeePct}
                                        selectorDataPointId={11644}
                                        fieldName = "11644"
                                        setValue={setValue}
                                    />


                                    {/*-- ***************************************************   PLUS MINUS   **********************************************************/}


                                    <Stack direction="row" alignItems="center" spacing={2}>
                                            <Typography>
                                                Fee Subject to Account Maximum:
                                            </Typography>

                                            <Controller
                                                name="12628"
                                                control={control}
                                                defaultValue={selectorOverheadSubToMax ?? "na"}
                                                render={({ field }) => (
                                                    <RadioGroup
                                                        {...field}
                                                        row
                                                    >
                                                        <FormControlLabel
                                                            value="na"
                                                            control={<Radio />}
                                                            label="N/A"
                                                        />
                                                        <FormControlLabel
                                                            value="4638"
                                                            control={<Radio />}
                                                            label="Yes"
                                                        />
                                                        <FormControlLabel
                                                            value="4639"
                                                            control={<Radio />}
                                                            label="No"
                                                        />
                                                    </RadioGroup>
                                                )}
                                            />

                                        </Stack>

                                    </Stack>

                                </div>



{/*-- ************************************************************************************************************************/}
{/*-- ******************************************** OVERHEAD ROW 2   **********************************************************/}
{/*-- ************************************************************************************************************************/}


                                {/*-- ***************************************************  MAX OUT  **********************************************************/}


                                    { (selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Account: Other"  || selectorHelperMode === "Account: Residuals") &&
                                <Stack direction="row" spacing={3}     alignItems="center" >

                                    <Box sx={{width: 150}}>

                                        <Typography>Max Fee:</Typography>
                                    </Box>

                                    <DynamicCdpvValueField
                                        selectorContext={"overheadMaxFee"}
                                        selectorLabel={ "Dollar Max"}
                                        selectorDataType={'DOLLARS'}
                                        selectorValue={selectorOverheadMaxFee}
                                        selectorDataPointId={12629}
                                        fieldName = {"12629"}
                                        setValue={setValue}
                                    />


                                    <Typography sx={{pr: 6}}>Or</Typography>


                                    <DynamicCdpvValueField
                                        selectorContext={"overheadMaxResultPct"}
                                        selectorLabel={ "Percentage"}
                                        selectorDataType={'PERCENTAGE'}
                                        selectorValue={selectorOverheadMaxFeePct}
                                        selectorDataPointId={12632}
                                        fieldName = "12632"
                                        setValue={setValue}
                                    />

                                    <Typography>of</Typography>

                                    <div>
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                        >
                                            <InputLabel>Account</InputLabel>

                                            <Select
                                                id="maxOverheadResultLimiter"
                                                multiple
                                                value={selectorOverheadMaxFeeLimiter ?? []}
                                                renderValue={(selected) =>
                                                    selected?.length > 0
                                                        ? "(click to view selected values)"
                                                        : ""
                                                }
                                                label="Basis"
                                                onChange={(event) => {
                                                    const newValues = event.target.value;

                                                    if (newValues.includes("__CLEAR_ALL__")) {
                                                        handleMultiChange("12631", []);
                                                    } else {
                                                        handleMultiChange("12631", newValues);
                                                    }
                                                }}
                                            >
                                                <MenuItem
                                                    value="__CLEAR_ALL__"
                                                    disabled={(selectorOverheadMaxFeeLimiter ?? []).length === 0}
                                                >
                                                    <ListItemText
                                                        primary="Clear All"
                                                        primaryTypographyProps={{
                                                            fontWeight: "bold"
                                                        }}
                                                    />
                                                </MenuItem>

                                                <Divider />

                                                {accountDropdown.map((accountItem) => {
                                                    const value = `^12571^${accountItem.expressionText}`;

                                                    return (
                                                        <MenuItem
                                                            key={accountItem.cdpId}
                                                            value={value}
                                                            sx={{
                                                                pl: accountItem.hierarchyLevel * 2
                                                            }}
                                                        >
                                                            <Checkbox
                                                                checked={(selectorOverheadMaxFeeLimiter ?? []).includes(value)}
                                                            />

                                                            <ListItemText
                                                                primary={accountItem.accountName}
                                                                primaryTypographyProps={{
                                                                    fontWeight:
                                                                        accountItem.hierarchyLevel === 1
                                                                            ? "bold"
                                                                            : "normal"
                                                                }}
                                                            />
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>

                                        </FormControl>
                                    </div>

                                </Stack>}


{/*-- ************************************************************************************************************************/}
{/*-- ******************************************** OVERHEAD ROW 3   **********************************************************/}
{/*-- ************************************************************************************************************************/}

{/*-- ***************************************************  MAX IN  **********************************************************/}

                                <Stack direction="row" spacing={3}     alignItems="center" >

                                    <Box sx={{width: 150}}>

                                        <Typography>Max Basis:</Typography>
                                            </Box>

                                            <DynamicCdpvValueField
                                            selectorContext={"overheadMaxBasis"}
                                            selectorLabel={ "Dollar Max"}
                                            selectorDataType={'DOLLARS'}
                                            selectorValue={selectorOverheadMaxBasis}
                                            selectorDataPointId={12630}
                                            fieldName = {"12630"}
                                            setValue={setValue}
                                        />


                                        <Typography sx={{pr: 6}}>Or</Typography>


                                        <DynamicCdpvValueField
                                            selectorContext={"overheadMaxBasisPct"}
                                            selectorLabel={ "Percentage"}
                                            selectorDataType={'PERCENTAGE'}
                                            selectorValue={selectorOverheadMaxBasisPct}
                                            selectorDataPointId={12634}
                                            fieldName = "12634"
                                            setValue={setValue}
                                        />

                                        <Typography>of</Typography>

                                        <div>
                                            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                            >
                                                <InputLabel>Account</InputLabel>

                                                <Select
                                                    id="maxOverheadBasisLimiter"
                                                    multiple
                                                    value={selectorOverheadMaxBasisLimiter ?? []}
                                                    renderValue={(selected) =>
                                                        selected?.length > 0
                                                            ? "(click to view selected values)"
                                                            : ""
                                                    }
                                                    label="Basis"
                                                    onChange={(event) => {
                                                        const newValues = event.target.value;

                                                        if (newValues.includes("__CLEAR_ALL__")) {
                                                            handleMultiChange("12633", []);
                                                        } else {
                                                            handleMultiChange("12633", newValues);
                                                        }
                                                    }}
                                                >
                                                    <MenuItem
                                                        value="__CLEAR_ALL__"
                                                        disabled={(selectorOverheadMaxBasisLimiter ?? []).length === 0}
                                                    >
                                                        <ListItemText
                                                            primary="Clear All"
                                                            primaryTypographyProps={{
                                                                fontWeight: "bold"
                                                            }}
                                                        />
                                                    </MenuItem>

                                                    <Divider />

                                                    {accountDropdown.map((accountItem) => {
                                                        const value = `^12571^${accountItem.expressionText}`;

                                                        return (
                                                            <MenuItem
                                                                key={accountItem.cdpId}
                                                                value={value}
                                                                sx={{
                                                                    pl: accountItem.hierarchyLevel * 2
                                                                }}
                                                            >
                                                                <Checkbox
                                                                    checked={(selectorOverheadMaxBasisLimiter ?? []).includes(value)}
                                                                />

                                                                <ListItemText
                                                                    primary={accountItem.accountName}
                                                                    primaryTypographyProps={{
                                                                        fontWeight:
                                                                            accountItem.hierarchyLevel === 1
                                                                                ? "bold"
                                                                                : "normal"
                                                                    }}
                                                                />
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>

                                            </FormControl>
                                        </div>

                                </Stack>

{/*-- ************************************************************************************************************************/}
{/*-- ******************************************** OVERHEAD CLOSING   ********************************************************/}
{/*-- ************************************************************************************************************************/}


                            </Stack>
                        </Box>
                    </Collapse>
                </Box>
                    </div>
                        }





{/*-- ************************************************************************************************************************/}
{/*-- ***************************************************   CHECKBOXES  **********************************************************/}
{/*-- ************************************************************************************************************************/}

        {(selectorHelperMode !== "Bonus" && selectorHelperMode !== "Account: Residuals")  &&
                    <div>
              <br/>
                    </div>
                }
                {
                    (selectorHelperMode !== "Participant Net Share") &&
                    <div>
                {/*<Stack direction="row" spacing={4} >*/}
                {(selectorHelperMode === "Account: Mapped Prod" || selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode === "Line Item" || selectorHelperMode === "Cost Item") &&
                <DynamicMultiSelectGridWide
                    selectorDataPointId={
                        selectorHelperMode === "Account: Mapped Dist" || selectorHelperMode  === "Line Item" ? 12023 : 12033
                    }
                    // selectorDataPointId ={12023}
                    selectorLabel = "Account"
                    selectorTooltip = "At least one Account must be selected"
                    clearAll = {clearAll}
                    fieldValue = "account"
                    fieldName = "12023"
                    fieldNameMethod = "12074"
                    setValue = {setValue}
                    defaultValue = {selectorContents?.["12023"] ?? []}
                    defaultFilteringMethod={selectorContents?.["12074"] ?? "Includes"}
                    // setSelectedFilteringMethod = {setSelectedFilteringMethod}
                />}
              {(selectorHelperMode !== 'Summary Item' && selectorHelperMode !== "Cost Item" && selectorHelperMode !== "Account: Residuals") &&
                  // (selectorHelperMode !== "Participant Gross Share" && selectorHelperMode !== "Participant Net Share") &&
                  <div>
                <br/>
                <br/>
                <DynamicMultiSelectGridWide
                    selectorDataPointId ={12025}
                    selectorLabel = "Market"
                    selectorTooltip = "If no value is selected, all Markets will be included."
                    clearAll = {clearAll}
                    fieldValue = "market"
                    fieldName= "12025"
                    fieldNameMethod = "12077"
                    setValue = {setValue}
                    defaultValue = {selectorContents?.["12025"] ?? []}
                    defaultFilteringMethod={
                        selectorContents?.["12077"] || "Includes"
                    }
                    // defaultFilteringMethod={selectorContents?.["12077"] ?? "Includes"}
                />
                <br/>
                <br/>
                <DynamicMultiSelectGridWide
                    selectorDataPointId ={12027}
                    selectorLabel = "Distribution Channel"
                    selectorTooltip = "If no value is selected, all Distribution Channels will be included."
                    clearAll = {clearAll}
                    fieldValue = "distributionChannel"
                    fieldName = "12027"
                    fieldNameMethod = "12080"
                    setValue = {setValue}
                    defaultValue = {selectorContents?.["12027"] ?? []}
                    defaultFilteringMethod={selectorContents?.["12080"] ?? "Includes"}
                />
                <br/>
                <br/>
                <DynamicMultiSelectGridWide
                    selectorDataPointId ={12020}
                    selectorLabel = "Region"
                    selectorTooltip = "Select a Region or Country but not both, or leave blank."
                        clearAll = {clearAll}
                    fieldValue = "region"
                    fieldName = "12020"
                    fieldNameMethod = "12083"
                    setValue = {setValue}
                    defaultValue = {selectorContents?.["12020"] ?? []}
                    defaultFilteringMethod={selectorContents?.["12083"] ?? "Includes"}
                />
                <br/>
                <br/>
                <DynamicMultiSelectGridWide
                    selectorDataPointId ={12019}
                    selectorLabel = "Country"
                    selectorTooltip = "If a Country is selected and it is in a Region that has been selected then the Country will be excluded."
                    clearAll = {clearAll}
                    fieldValue = "country"
                    fieldName = "12019"
                    fieldNameMethod = "12086"
                    setValue = {setValue}
                    defaultValue = {selectorContents?.["12019"] ?? []}
                    defaultFilteringMethod={selectorContents?.["12086"] ?? "Includes"}
                />
                <br/>
                <br/>
                <DynamicMultiSelectGridWide
                    selectorDataPointId ={12022}
                    selectorLabel = "Language"
                    selectorTooltip = "If no value is selected, all Languages will be included."
                    clearAll = {clearAll}
                    fieldValue = "language"
                    fieldName = "12022"
                    fieldNameMethod = "12089"
                    setValue = {setValue}
                    defaultValue = {selectorContents?.["12022"] ?? []}
                    defaultFilteringMethod={selectorContents?.["12089"] ?? "Includes"}
                />
                  </div>
              }
                  </div>
            }
                {/*</Stack>*/}
                <br/>
                <br/>
                <br/>
                {/*<Button*/}
                {/*    type= "submit"*/}
                {/*>Submit</Button>*/}
                {/*<Button onClick={() => closeQfDrawer()}>Cancel</Button>*/}
            </Box>
        </form>
    );

    // ****************** END RETURN ****************************

}
